<template>
    <div class="row order-info mb-5">
        <div class="col-md-12">
            <span
                class="text-underline cursor-pointer text-muted"
                style="position: absolute; top: -25px"
                @click="$router.back()"
                ><i class="fa fa-arrow-left" aria-hidden="true"></i> Go
                back</span
            >
            <div class="d-flex align-items-center">
                <h3 v-if="user.is_demo" class="m-0 pr-2">Order #ORD-12345</h3>
                <h3 v-else class="m-0 pr-2">
                    Order #{{
                        orderInfo.order_number == 0
                            ? orderInfo.id
                            : orderInfo.order_number
                    }}
                </h3>
                <span
                    v-if="
                        !orderInfo.is_sync &&
                        orderInfo.order_status?.toLowerCase() ==
                            'pending approval'
                    "
                    class="px-1 view-action"
                    @click="editOrder(orderInfo)"
                >
                    (<i class="fa fa-pencil" aria-hidden="true"></i> EDIT
                </span>
                <span
                    v-if="orderInfo.order_status == 'Pending Approval'"
                    class="px-1"
                    >|</span
                >
                <span
                    v-if="orderInfo.order_status == 'Pending Approval'"
                    class="px-1 view-action"
                    @click="confirmDeleteModal(orderInfo)"
                >
                    <i class="fa fa-trash" aria-hidden="true"></i> DELETE)
                </span>
            </div>
            <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>PO Number:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span v-if="user.is_demo">PO-12345</span>
                            <span v-else>{{ orderInfo.po_number }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Order Date:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ orderInfo.order_date }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Dealer:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span
                                >{{ orderInfo.location?.name }}<br />
                                {{ orderInfo.location?.address }},
                                {{ orderInfo.location?.city }},
                                {{ orderInfo.location?.state }},
                                {{ orderInfo.location?.zip_code }}
                            </span>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-sm-3 col-md-2">
                            <label>Pricelist:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span v-if="orderInfo.pricelist != null">
                                {{ orderInfo.pricelist.pricelist_name }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Placed By:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span v-if="orderInfo.user"
                                >{{ orderInfo.user?.name }} ({{
                                    orderInfo.user?.email
                                }}), {{ orderInfo.user?.phone }}</span
                            >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Requested Delivery Date:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ orderInfo.requested_delivery_date }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Status:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <div class="row">
                                <div class="col-sm-12">
                                    <!-- <span
                                        v-if="orderInfo.is_speq && orderInfo.speq_order_status != 0"
                                        class="px-4 py-2 mr-3 speq-order-status"
                                        :class="orderInfo.speq_order_status == 1 ? 'open' : 'sold'"
                                        >{{ orderInfo.speq_order_status == 1 ? 'Open' : 'Sold' }}</span
                                    >
                                    <span
                                        v-else
                                        class="px-4 py-2 mr-3 order-status"
                                        :class="orderInfo.order_status?.toLowerCase()"
                                        >{{ orderInfo.order_status }}</span
                                    > -->

                                    <template v-if="orderInfo.is_speq && orderInfo.speq_order_status != 0">
                                        <span
                                            v-if="orderInfo.is_speq && orderInfo.speq_order_status != 0"
                                            class="px-4 py-2 mr-3 speq-order-status"
                                            :class="orderInfo.speq_order_status == 1 ? 'open' : 'sold'"
                                            >{{ orderInfo.speq_order_status == 1 ? 'Open' : 'Sold' }}</span
                                        >
                                    </template>
                                    <template v-else>
                                        <span
                                            class="px-4 py-2 mr-3 order-status"
                                            :class="orderInfo.order_status?.toLowerCase()"
                                            >{{ orderInfo.order_status }}</span
                                        >

                                        <!-- <span
                                           v-if="user.role.id == 1 && orderInfo.order_status == 'Confirmed'"
                                            class="add-button btn btn-action"
                                            @click="splitOrder(orderInfo.id)"
                                            >TEST: Split Order</span
                                        > -->

                                    </template>
                                    
                                    <span
                                        v-if="
                                            (user.role.id == 1 || user.role.id == 4 || user.role.id == 5) &&
                                            orderInfo.order_status == 'Pending Approval'
                                        "
                                        class="add-button btn btn-action"
                                        @click="confirmModal(orderInfo.id)"
                                        >Confirm and Approve Order</span
                                    >

                                    <span
                                        v-if="orderInfo.is_speq && orderInfo.speq_order_status == 1"
                                        class="add-button btn btn-action"
                                        @click="openModalUploadDocs(orderInfo)"
                                        >Mark as Sold</span
                                    >
                                </div>
                            </div>
                            <div class="row my-4" v-if="user.role.id == 1 && orderInfo.user?.is_flagged">
                                <div class="col-sm-12">
                                    <span @click="viewUser(orderInfo.user)" class="text-danger flagged cursor-pointer alert alert-danger">
                                        This account has been flagged and must be reviewed before the order can be approved
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="orderInfo.attachments" class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>PO Attachment:</label>
                        </div>
                        <div class="col-sm-9 col-md-10 pt-2">
                            <a :href="orderInfo.attachments" target="_blank">
                                <img
                                    v-if="
                                        orderInfo.attachments
                                            .split('.')
                                            .pop() == 'pdf'
                                    "
                                    src="/images/pdf2.png"
                                    alt="SilencerCo"
                                    class="preview-img3"
                                    style="height: 4ch; width: auto"
                                />
                                <img
                                    v-else
                                    :src="orderInfo.attachments"
                                    class="preview-img3"
                                    style="height: 10ch; width: auto"
                                />
                            </a>
                        </div>
                    </div>
                    <div v-if="orderInfo.customer_name" class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Customer Name:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ orderInfo.customer_name }}</span>
                        </div>
                    </div>
                    <div v-if="orderInfo.customer_phone" class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Customer Phone:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ orderInfo.customer_phone }}</span>
                        </div>
                    </div>
                    <div v-if="orderInfo.customer_email" class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Customer Email:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ orderInfo.customer_email }}</span>
                        </div>
                    </div>
                    <div v-if="orderInfo.customer_address" class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Customer Address:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ orderInfo.customer_address }}</span>
                        </div>
                    </div>
                </div>

                <div v-if="orderInfo.payment && user.role.id == 1" class="row">
                    <div class="col-sm-12 col-md-6">
                        <div class="row">
                            <div class="col-sm-3 col-md-2">
                                <label>Payment Status: </label>
                            </div>
                            <div class="col-sm-9 col-md-2">
                                <div
                                    v-if="orderInfo.is_paid == 1"
                                    class="order-status paid mt-1"
                                >
                                    PAID
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 col-md-2">
                                <label>Reference #:</label>
                            </div>
                            <div class="col-sm-9 col-md-10">
                                <span>{{ orderInfo.payment.ref_id }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 col-md-2">
                                <label>Payment Information:</label>
                            </div>
                            <div class="col-sm-9 col-md-10">
                                <span>
                                    <template
                                        v-if="
                                            orderInfo.payment.payment_type ==
                                            'credit'
                                        "
                                    >
                                        <strong class="mr-2">Card Name:</strong
                                        >{{ orderInfo.payment.first_name }}
                                        {{ orderInfo.payment.last_name }}<br />
                                    </template>
                                    <template
                                        v-if="
                                            orderInfo.payment.payment_type ==
                                            'credit'
                                        "
                                    >
                                        <strong class="mr-2">Card #:</strong
                                        >{{ orderInfo.payment.last_four }}
                                        <br />
                                    </template>
                                    <template
                                        v-if="
                                            orderInfo.payment.payment_type ==
                                            'credit'
                                        "
                                    >
                                        <strong class="mr-2"
                                            >Card Expiry:</strong
                                        >{{ orderInfo.payment.expiration }}
                                    </template>

                                    <template
                                        v-if="
                                            orderInfo.payment.payment_type ==
                                            'bank'
                                        "
                                    >
                                        <strong class="mr-2"
                                            >Account Number:</strong
                                        >{{ orderInfo.payment.account_number }}
                                        <br />
                                    </template>
                                    <template
                                        v-if="
                                            orderInfo.payment.payment_type ==
                                            'bank'
                                        "
                                    >
                                        <strong class="mr-2"
                                            >Account Type:</strong
                                        >{{ orderInfo.payment.account_type
                                        }}<br />
                                    </template>
                                    <template
                                        v-if="
                                            orderInfo.payment.payment_type ==
                                            'bank'
                                        "
                                    >
                                        <strong class="mr-2"
                                            >Account Name:</strong
                                        >{{ orderInfo.payment.name_on_account
                                        }}<br />
                                    </template>
                                    <template
                                        v-if="
                                            orderInfo.payment.payment_type ==
                                            'bank'
                                        "
                                    >
                                        <strong class="mr-2">Routing:</strong
                                        >{{ orderInfo.payment.routing_number
                                        }}<br />
                                    </template>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <h5>Order Lines</h5>
            <table class="table table-responsive table-striped">
                <thead class="thead-light">
                    <tr>
                        <th
                            class="cursor-pointer-with-hover"
                            style="width: 10em"
                            @click="sort('sku')"
                        >
                            SKU
                        </th>
                        <th
                            class="cursor-pointer-with-hover"
                            @click="sort('name')"
                        >
                            Product Name
                        </th>
                        <th
                            class="text-right cursor-pointer-with-hover"
                            style="width: 15em"
                            @click="sort('quantity')"
                        >
                            Quantity
                        </th>
                        <th
                            class="text-right cursor-pointer-with-hover"
                            style="width: 15em"
                            @click="sort('delivered')"
                        >
                            Delivered
                        </th>
                        <th
                            class="text-right cursor-pointer-with-hover"
                            style="width: 10em"
                            @click="sort('unit_cost')"
                        >
                            Unit Cost
                        </th>
                        <th
                            class="text-right cursor-pointer-with-hover"
                            style="width: 10em"
                            @click="sort('discount')"
                        >
                            Discount %
                        </th>
                        <th
                            class="text-right cursor-pointer-with-hover"
                            style="width: 10em"
                            @click="sort('total')"
                        >
                            Subtotal
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in sortedOrderLines" :key="item.id">
                        <td>{{ item.sku }}</td>
                        <td>{{ item.name }}</td>
                        <td class="text-right">{{ item.quantity }}</td>
                        <td class="text-right">{{ item.delivered }}</td>
                        <td class="text-right">
                            ${{ $filters.moneyFormat(item.unit_cost) }}
                        </td>
                        <td class="text-right">{{ item.discount }}%</td>
                        <td class="text-right">
                            ${{ $filters.moneyFormat(item.total) }}
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td class="subtotal text-right" colspan="2"></td>
                        <td class="subtotal text-right"></td>
                        <td class="subtotal text-right"></td>
                        <td class="subtotal text-right"></td>
                        <td colspan="2" class="subtotal text-right">
                            <h6>
                                <label class="pr-3">SHIPPING FEE:</label>
                                ${{
                                    $filters.moneyFormat(orderInfo.shipping_fee)
                                }}
                            </h6>
                        </td>
                    </tr>
                    <tr>
                        <td class="subtotal text-right" colspan="2">
                            <!-- <label>TOTAL ITEMS</label> -->
                        </td>
                        <td class="subtotal text-right">
                            <h6>
                                <label class="pr-3">TOTAL ITEMS:</label>
                                {{ totalQuantity }}
                            </h6>
                        </td>
                        <td class="subtotal text-right">
                            <h6>
                                <label class="pr-3">TOTAL DELIVERED:</label>
                                {{ totalDelivered }}
                            </h6>
                        </td>
                        <td class="subtotal text-right">
                            <!-- <label>GRAND TOTAL</label> -->
                        </td>
                        <td colspan="2" class="subtotal text-right">
                            <h6>
                                <label class="pr-3">GRAND TOTAL:</label>
                                ${{ $filters.moneyFormat(orderInfo.total) }}
                            </h6>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div class="col-md-12">
            <h5>Invoices</h5>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th style="width: 15em">Invoice Number</th>
                        <th style="width: 12em">Source</th>
                        <th style="width: 10em">Invoice Date</th>
                        <th style="width: 10em">Due Date</th>
                        <th>Dealer</th>
                        <th class="text-right" style="width: 8em">Total</th>
                        <th class="text-right" style="width: 8em">
                            Amount Due
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template
                        v-for="invoice in invoicesByOrderNumber"
                        :key="invoice.id"
                    >
                        <tr>
                            <td class="hyperlink" @click="viewInvoice(invoice)">
                                <b v-if="user.is_demo">INV-12345</b>
                                <b v-else>{{ invoice.invoice_number }}</b>
                            </td>
                            <td>
                                <span v-if="user.is_demo">ORD-12345</span>
                                <span v-else>{{ invoice.invoice_origin }}</span>
                            </td>
                            <td>{{ invoice.invoice_date }}</td>
                            <td>{{ invoice.due_date }}</td>
                            <td>{{ invoice.location.name }}</td>
                            <td class="text-right">
                                ${{ $filters.moneyFormat(invoice.total) }}
                            </td>
                            <td class="text-right">
                                ${{ $filters.moneyFormat(invoice.amount_due) }}
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <div class="col-md-12 mt-5">
            <h5>Shipment Information</h5>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th>Tracking Number</th>
                        <th>Carrier</th>
                        <th>Shipment Date</th>
                    </tr>
                </thead>
                <tbody>
                    <template
                        v-for="invoice in invoicesByOrderNumber"
                        :key="invoice.id"
                    >
                        <tr v-if="invoice.invoice_shipment?.tracking_number">
                            <td>
                                {{ invoice.invoice_shipment?.tracking_number }}
                            </td>
                            <td>{{ invoice.invoice_shipment?.carrier }}</td>
                            <td>
                                {{ invoice.invoice_shipment?.shipment_date }}
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <!-- Confirmation modal -->
        <b-modal v-model="modalShow" hide-footer>
            <Confirmation
                v-if="modalShow"
                :title="'Are you sure you want to confirm and approve this order?'"
                @custom-func="updateOrderStatus"
                @close-modal="closeModal"
            />
        </b-modal>

        <!-- Delete modal -->
        <b-modal v-model="modalShowConfirm" hide-footer>
            <Confirmation
                v-if="modalShowConfirm"
                :title="'Are you sure you want to delete this order?'"
                @custom-func="deleteOrderById"
                @close-modal="closeModalConfirm"
            />
        </b-modal>

        <!-- Upload Document modal -->
        <b-modal
            class="speq-upload"
            v-model="modalShowUploadDocs"
            hide-footer
        >
            <SpeqUploadDocumentsModal
                v-if="modalShowUploadDocs"
                :modal-data="modalData"
                @close-modal="closeModalUploadDocs"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import Confirmation from "@/components/Confirmation.vue";
import SpeqUploadDocumentsModal from '@/components/speq/modals/SpeqUploadDocumentsModal.vue';

export default {
    props: ["id", "order_number"],
    emits: [],
    components: {
        Confirmation,
        SpeqUploadDocumentsModal
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });
        let orderInfo = computed(function () {
            return store.state.orderInfo;
        });
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let invoicesByOrderNumber = computed(function () {
            return store.state.invoicesByOrderNumber;
        });

        function setOrderInfo(order) {
            store.commit("setOrderInfo", order);
        }

        function updateOrderStatus(request) {
            store.dispatch("updateOrderStatus", request);
        }

        function getOrderByOrderNumber(orderNum) {
            store.dispatch("getOrderByOrderNumber", orderNum);
        }

        function getInvoicesByOrderNumber(orderNum) {
            store.dispatch("getInvoicesByOrderNumber", orderNum);
        }

        function setUserInfo(order) {
            store.commit("setUserInfo", order);
        }

        onMounted(() => {});

        return {
            store,
            user,
            orderInfo,
            currentLocation,
            invoicesByOrderNumber,
            setOrderInfo,
            updateOrderStatus,
            getOrderByOrderNumber,
            getInvoicesByOrderNumber,
            setUserInfo
        };
    },
    data() {
        return {
            orderId: null,
            modalShow: false,
            modalShowConfirm: false,
            reqOrder: {
                id: null,
                location_id: null,
            },
            currentSort: "sku",
            currentSortDir: "asc",
            modalShowUploadDocs: false,
            modalData: {},
        };
    },
    computed: {
        totalQuantity() {
            let quantity = 0;
            if (this.orderInfo.line_items) {
                this.orderInfo.line_items.forEach((data, idx) => {
                    quantity += data.quantity;
                });
            }
            return quantity;
        },
        totalDelivered() {
            let delivered = 0;
            if (this.orderInfo.line_items) {
                this.orderInfo.line_items.forEach((data, idx) => {
                    delivered += data.delivered;
                });
            }
            return delivered;
        },
        sortedOrderLines() {
            if (this.orderInfo.line_items) {
                return this.orderInfo.line_items.sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === "desc") modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort])
                        return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort])
                        return 1 * modifier;
                    return 0;
                });
            }
        },
    },
    mounted() {
        // if ( this.order_number != 'record' ) {
        //     this.getOrderByOrderNumber({order_number: this.order_number})
        // }
        // this.getInvoicesByOrderNumber({order_number: this.orderInfo.order_number})

        this.store.dispatch("getOrderByOrderNumber", {
            id: this.id,
            order_number: this.order_number,
        });
    },
    methods: {
        editOrder(order) {
            this.setOrderInfo(order);
            this.$router.push({ name: "speqOrderEdit" });
        },
        confirmModal(order_id) {
            this.orderId = order_id;
            this.modalShow = !this.modalShow;
        },
        closeModal() {
            this.modalShow = !this.modalShow;
        },
        updateOrderStatus() {
            let request = {
                id: this.orderId,
                location_id: this.currentLocation.id,
            };
            // this.orderInfo.status = this.orderInfo.status == 'Pending' ? 'Confirmed' : 'Pending';
            this.orderInfo.order_status =
                this.orderInfo.order_status == "Pending Approval"
                    ? "Confirmed"
                    : "Pending Approval";
            this.updateOrderStatus(request);
            window.emitter.emit("alertSuccess", {
                message: "Order has been confirmed and approved successfully!",
            });
        },
        confirmDeleteModal(order) {
            this.reqOrder = {
                id: order.id,
                location_id: this.currentLocation.id,
            };
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        deleteOrderById() {
            this.store.dispatch("deleteOrder", this.reqOrder).then((resp) => {
                window.emitter.emit("alertSuccess", {
                    message: "Order deleted successfully!",
                });
                this.$router.push({ name: "orders" });
            });
        },
        closeModalConfirm() {
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        viewInvoice(invoice) {
            this.$router.push({
                name: "invoiceInfo",
                params: { id: invoice.id },
            });
        },
        sort(s) {
            //if s == current sort, reverse
            if (s === this.currentSort) {
                this.currentSortDir =
                    this.currentSortDir === "asc" ? "desc" : "asc";
            }
            this.currentSort = s;
        },
        markAsSold() {
            this.store.dispatch("markAsSold", this.orderInfo.id).then(resp => {
                this.store.dispatch("getOrderByOrderNumber", {
                    id: this.id,
                    order_number: this.order_number,
                    location_id: this.orderInfo.location_id
                });
            });
        },
        viewUser(user) {
            this.setUserInfo(user);
            this.$router.push({ name: "speqUserInfo", params: { id: user.id } });
        },
        openModalUploadDocs(data) {
            this.modalData = data;
            this.modalShowUploadDocs = !this.modalShowUploadDocs;
        },
        closeModalUploadDocs() {
            this.store.dispatch("getOrderByOrderNumber", {
                id: this.id,
                order_number: this.order_number,
            });
            this.modalShowUploadDocs = !this.modalShowUploadDocs;
        },
        splitOrder(order_id) {

            window.emitter.emit("changeLoaderStatus", true);
            axios
                .get("/api/split-order/" + order_id)
                .then((data) => {
                    
                    window.emitter.emit("changeLoaderStatus", false);

                    this.$router.push({ name: "speqOpenSerialNumbers" });
                });
        }
    },
};
</script>
